import styled from 'styled-components';
import { device } from '../../../assets/styles/device';

// https://github.com/microsoft/TypeScript/issues/47663#issuecomment-1519138189
export const MfaBackground: ReturnType<typeof styled.div> = styled.div`
  background: linear-gradient(#4a535b, #1e2d54);
  width: 100%;
  height: 100vh;
  position: absolute;
`;

export const MfaLayout: ReturnType<typeof styled.div> = styled.div`
  overflow: auto;
  display: grid;
  grid-template-columns: 100px 447px auto 114px;
  grid-template-rows: 76px 1fr 123px;
  grid-template-areas:
    'header header . .'
    '. content content .'
    'footer footer . .';
  width: 100%;
  height: 100vh;
  align-items: center;
  @media ${device.mobile} {
    grid-template-columns: auto;
    grid-template-rows: 1fr 123px;
    grid-template-areas:
      'content'
      'footer';
  }
`;

export const MfaHeader: ReturnType<typeof styled.div> = styled.div`
  grid-area: header;
  padding-left: 21px;
  display: grid;
  grid-template-columns: 150px 1fr;
  justify-items: center;
  align-items: center;
  @media ${device.mobile} {
    display: none;
  }
`;

export const MfaContent: ReturnType<typeof styled.div> = styled.div`
  grid-area: content;
  min-height: auto;
  border: 1px;
  width: 600px;
  justify-self: center;
  border-radius: 5px 0px 0px 5px;
  @media ${device.mobile} {
    width: 100%;
  }
`;

export const StyledLink: ReturnType<typeof styled.div> = styled.div<{
  children?: React.ReactNode;
  onClick?: () => void;
}>`
  display: block;
  text-align: center;
  font-size: 18px;
  cursor: pointer;
  color: #00a7ee;
`;
export const StyledButton: ReturnType<typeof styled.div> = styled.button`
  margin: 24px 0px;
  padding: 10px 0;
  width: 100%;
  background: #126dff;
  color: #ffffff;
  font-size: 16px;
  border-radius: 5px;
  border: none;
  cursor: pointer;
  &:disabled {
    background: #8e8e8e;
  }
`;
export const Container: ReturnType<typeof styled.div> = styled.div`
  margin-bottom: 24px;
  border-radius: 5px;
`;
export const ContainerHeader: ReturnType<typeof styled.div> = styled.div`
  padding: 30px 0;
  text-align: center;
  background-color: #f0f2f3;
  border-radius: 4px 4px 0 0;
  @media ${device.mobile} {
    background-color: transparent;
    & > svg {
      margin-bottom: 7px;
      width: 58px;
      height: 58px;
    }
  }
`;
export const ContainerHeading: ReturnType<typeof styled.div> = styled.div`
  font-weight: bold;
  font-size: 28px;
  color: #4a535b;
  @media ${device.mobile} {
    color: #ffffff;
    font-size: 18px;
  }
`;
export const ContainerContent: ReturnType<typeof styled.div> = styled.div`
  background: #ffffff;
  padding: 10px 0;
  & a {
    color: #00bcff;
  }
  border-radius: 0 0 4px 4px;
  @media ${device.mobile} {
    margin: 0 8px;
    border-radius: 4px;
  }
`;

export const SignOutButton: ReturnType<typeof styled.div> = styled(StyledLink)<{
  children?: React.ReactNode;
  onClick: () => void;
}>`
  display: none;
  margin-bottom: 12px;
  font-weight: 700;
  @media ${device.mobile} {
    display: block;
  }
`;